import { isSsr } from 'utils/ssrHelper';

export const getServerData = (key) => {
  if (isSsr()) return process.env[key];
  return window.SERVER_DATA[key];
};
